import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  Form,
  Image,
  Grid,
  Table,
  Icon,
  Button,
  Comment,
  CommentGroup,
  GridColumn,
  CommentMetadata,
  GridRow,
  Modal,
  ModalActions,
  ModalContent,
  ModalHeader,
  Segment,
  Divider,
  Header,
  List,
  Message,
  Popup,
  Label,
} from "semantic-ui-react";
import { useDropzone } from "react-dropzone";
import { useFormik, Field, FieldArray, FormikProvider, getIn } from "formik";
import { AirEmissionsform } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { ENV, pollutants, units_11 } from "../../../../utils";
import {
  formatDateView,
  formatDateHourCompleted,
} from "../../../../utils/formatDate";
import { BasicModal } from "../../../Shared";
import { initialValues, validationSchema } from "./AirEmissionsForm.form";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { decrypt, encrypt } from "../../../../utils/cryptoUtils";
import { PERIODS } from "../../../../utils";
import { t, convertPeriodsEngToEsp } from "../../../../utils/converts";
import "./AirEmissionsForm.scss";
import { useLanguage } from "../../../../contexts";
import { determineAirEmissionsUnits } from "../../../../utils/dataAndFormulas/airemissionsForms";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Importa el CSS de react-toastify
import {
  isAdmin,
  isEditor,
  isReviewer,
} from "../../../../utils/checkPermission";
const airEmissionsFormController = new AirEmissionsform();

export function AirEmissionsForm(props) {
  const {
    onClose,
    onReload,
    airEmissionsForm,
    siteSelected,
    year,
    period,
    configFormData,
    unitsRecorded,
  } = props;

  const { accessToken } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [fieldName, setFieldName] = useState("");
  const [listPeriods, setListPeriods] = useState([]);
  const [yearComplete, setYearComplete] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const [newFiles, setNewFiles] = useState({});

  // Lector de documentos de emisiones al aire
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const [invoiceResults, setInvoiceResults] = useState([]);
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const invoiceInputRef = useRef(null);

  const { user } = useAuth();

  const location = useLocation();
  // const { siteSelected } = location.state || {};

  const { translations } = useLanguage();

  const t = (key) => translations[key] || key; // Función para obtener la traducción

  if (!siteSelected) {
    // // Manejo de caso donde no hay datos en state (por ejemplo, acceso directo a la URL)
    // return <div>No se encontraron detalles de producto.</div>;
  }

  const navigate = useNavigate();

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  const openUpdateSite = (data, name) => {
    setFieldName(name);
    setTitleModal(`${t("comments")}  ${data}`);
    onOpenCloseModal();
  };

  function setNestedError(obj, path, value) {
    const keys = path.split("."); // ["natural_gas", "unit"]
    let current = obj;
    keys.forEach((key, index) => {
      if (index === keys.length - 1) {
        current[key] = value; // asigna el mensaje de error al último nivel
      } else {
        if (!current[key]) current[key] = {}; // crea objeto si no existe
        current = current[key]; // baja al siguiente nivel
      }
    });
  }

  // Helper function to get approval status styling
  const getApprovalStatusStyle = (approvalStatus, isDisabled = false) => ({
    backgroundColor:
      approvalStatus === "approved"
        ? "#d4edda"
        : approvalStatus === "rejected"
        ? "#f8d7da"
        : approvalStatus === "pending"
        ? "#fff3cd"
        : "white",
    color:
      approvalStatus === "approved"
        ? "#155724"
        : approvalStatus === "rejected"
        ? "#721c24"
        : approvalStatus === "pending"
        ? "#856404"
        : "black",
    fontWeight: "bold",
    opacity: isDisabled ? 0.9 : 1,
  });

  const formik = useFormik({
    initialValues: initialValues(airEmissionsForm, period, year, unitsRecorded),
    // validationSchema: validationSchema(),

    validate: (values) => {
      const errors = {};
      try {
        validationSchema().validateSync(values, { abortEarly: false });
      } catch (err) {
        if (err.inner && err.inner.length > 0) {
          err.inner.forEach((e) => {
            errors[e.path] = e.message;
            // 🔹 Forzar touched para que aparezca el error visual
            setNestedError(errors, e.path, e.message);

            formik.setFieldTouched(e.path, true, false);
          });

          // Mostrar toast resumido
          const fields = err.inner
            .map((e) => {
              if (e.path.includes(".unit"))
                return `${t("unit")} (${t(e.path.split(".")[0])})`;
              if (e.path.includes(".value"))
                return `${t("value")} (${t(e.path.split(".")[0])})`;
              return t(e.path);
            })
            .join(", ");
          toast.error(`Faltan completar datos: ${t(fields)}`);
        }
      }
      return errors;
    },
    validateOnChange: false,
    onSubmit: async (formValue) => {
      try {
        if (!airEmissionsForm) {
          formValue.creator_user = user._id;
          formValue.date = new Date();
          if (user?.site) {
            formValue.site = user.site;
          } else {
            if (siteSelected) {
              formValue.site = siteSelected;
            }
            // else {
            //   // Desencriptar los datos recibidos
            //   if (!airEmissionsForm) {
            //     //const siteData = decrypt(siteSelected);
            //     //formValue.site = siteData;
            //     formValue.site = siteSelected;
            //   }
            // }
          }
          // Recorrer el JSON
          for (const clave in newFiles) {
            if (newFiles.hasOwnProperty(clave)) {
              let filesField = await uploadFiles(newFiles[clave]);

              // Combina los archivos nuevos con los existentes
              let finalFilesField = [...formValue[clave].files, ...filesField];

              formValue[clave].files = finalFilesField;
            }
          }
          const response =
            await airEmissionsFormController.createAirEmissionsForm(
              accessToken,
              formValue
            );

          if (response.code && response.code === 200) {
            toast.success(t("form_saved_successfully"));
          }
          //console.log(formValue);
        } else {
          // Recorrer el JSON
          for (const clave in newFiles) {
            if (newFiles.hasOwnProperty(clave)) {
              let filesField = await uploadFiles(newFiles[clave]);

              // Combina los archivos nuevos con los existentes
              let finalFilesField = [...formValue[clave].files, ...filesField];

              formValue[clave].files = finalFilesField;
            }
          }
          const response2 =
            await airEmissionsFormController.updateAirEmissionsForm(
              accessToken,
              airEmissionsForm._id,
              formValue
            );
          if (response2.code && response2.code === 200) {
            toast.success(t("form_saved_successfully"));
          }
        }
        // Retrasar el cierre del modal o el reload para dar tiempo a que la tostada se vea
        setTimeout(() => {
          onReload();
          if (onClose) {
            onClose();
          } else {
            // Después de guardar exitosamente, navegamos hacia atrás
            goBack();
          }
        }, 1000);
      } catch (error) {
        console.error(error);
      }
    },
  });

  const goBack = () => {
    navigate(`/admin/data/airEmissionsforms`, {
      state: { siteSelected: siteSelected },
    });
  };

  const processInvoiceFiles = async (files) => {
    if (!files || files.length === 0) return;
    setInvoiceLoading(true);
    try {
      const formData = new FormData();
      files.forEach(f => formData.append("files", f));
      const result = await airEmissionsFormController.readDocument(accessToken, formData);
      if (result.code === 200) {
        setInvoiceResults(result.results);
        setShowUploadModal(false);
        setShowInvoiceModal(true);
      } else {
        toast.error(result.msg || t("could_not_read_document"));
      }
    } catch (err) {
      toast.error(err?.msg || err?.message || t("error_processing_invoice"));
    } finally {
      setInvoiceLoading(false);
    }
  };

  const handleInvoiceFileChange = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    e.target.value = "";
    await processInvoiceFiles(files);
  };

  const handleApplyInvoiceData = (result) => {
    if (!result) return;
    if (result.period) formik.setFieldValue("period", result.period);
    if (result.year) formik.setFieldValue("year", result.year);
    setShowInvoiceModal(false);
    toast.success(t("invoice_data_applied"));
  };

  const uploadFiles = async (filesToUpload, formValue, field) => {
    const formData = new FormData();
    Array.from(filesToUpload).forEach((file) => {
      formData.append("files", file);
    });

    // Luego de preparar los datos, puedes hacer la solicitud POST
    if (filesToUpload.length === 0) {
      //console.log("no hay archivos");
      //setErrorMessage("Por favor, selecciona al menos un archivo.");
      return;
    }

    try {
      // Realizar la solicitud POST al backend
      const response = await airEmissionsFormController.uploadFileApi(
        accessToken,
        formData
      );
      if (response.code && response.code === 200) {
        return response.files;
      }
      return [];
    } catch (error) {
      //error
    }
  };

  // Generar una lista de años (por ejemplo, del 2000 al 2024)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 50 }, (_, i) => currentYear - i);

  const units = units_11;

  const listPollutants = pollutants;

  useEffect(() => {
    (async () => {
      try {
        const response =
          await airEmissionsFormController.getPeriodsAirEmissionsFormsBySiteAndYear(
            accessToken,
            siteSelected,
            formik.values.year
          );
        const periods = PERIODS.map((item) => item);
        const availablePeriods = periods
          .filter((period) => !response.periods.includes(period))
          .map((period) => period);

        setListPeriods(availablePeriods);

        // Detectar si todos los meses del año están completos
        if (availablePeriods.length === 0) {
          setYearComplete(true);
        } else {
          setYearComplete(false);
        }
      } catch (error) {
        console.error(error);
        setListPeriods([]);
        setYearComplete(false);
      }
    })();
  }, [formik.values.year]);

  function findActiveFieldByName(nameToFind) {
    if (
      configFormData &&
      configFormData.fields &&
      configFormData.fields.length > 0
    ) {
      return configFormData.fields.some(
        (field) => field.name === nameToFind && field.active
      );
    }
    return true;
  }

  return (
    <Form className="airemissions-form" onSubmit={formik.handleSubmit}>
      {airEmissionsForm ? (
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "12px" }}>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="calendar alternate outline" style={{ margin: 0 }} />
            {airEmissionsForm.date ? formatDateView(airEmissionsForm.date) : "-"}
          </span>
          <span style={{
            display: "inline-flex", alignItems: "center", gap: "6px",
            backgroundColor: "#EDEDED", color: "#555",
            borderRadius: "999px", padding: "5px 14px",
            fontSize: "0.85rem", fontWeight: 600,
          }}>
            <Icon name="user outline" style={{ margin: 0 }} />
            {airEmissionsForm.creator_user
              ? airEmissionsForm.creator_user.lastname
                ? airEmissionsForm.creator_user.lastname + " " + airEmissionsForm.creator_user.firstname
                : airEmissionsForm.creator_user.email
              : "-"}
          </span>
        </div>
      ) : null}
      {!airEmissionsForm ? (
        <>
          <Grid columns={2} divided>
            <GridRow style={{ display: "flex", gap: "20px" }}>
              {/* Año */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span> {t("year")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={years.map((year) => ({
                        key: year,
                        text: year,
                        value: year,
                      }))}
                      selection
                      onChange={(_, data) =>
                        formik.setFieldValue("year", data.value)
                      }
                      value={formik.values.year}
                      error={!!formik.errors.year && !!formik.touched.year}
                      style={{ flex: 1 }}
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.year && formik.errors.year}
                  </div>
                </div>
              </GridColumn>

              {/* Periodo */}
              <GridColumn style={{ flex: 1 }}>
                <div
                // style={{ display: "flex", flexDirection: "column", gap: "4px" }}
                >
                  <div
                  //style={{ display: "flex", alignItems: "center", gap: "8px" }}
                  >
                    <label style={{ minWidth: "80px", fontWeight: 600 }}>
                      <span style={{ color: "red" }}>*</span> {t("period")}
                    </label>
                    <Form.Dropdown
                      placeholder={t("select")}
                      options={listPeriods.map((period) => ({
                        key: period,
                        text: t(period),
                        value: period,
                      }))}
                      selection
                      value={formik.values.period}
                      onChange={(_, data) => {
                        // Actualiza el valor
                        formik.setFieldValue("period", data.value);
                        // Marca el campo como tocado (opcional)
                        formik.setFieldTouched("period", true, false);
                        // Borra el error si hay uno
                        formik.setFieldError("period", undefined);
                      }}
                      error={!!formik.errors.period && !!formik.touched.period}
                      style={{ flex: 1 }}
                      disabled={yearComplete}
                    />
                  </div>
                  <div
                    style={{
                      color: "red",
                      fontSize: "0.8em",
                      minHeight: "1.2em",
                    }}
                  >
                    {formik.touched.period && formik.errors.period}
                  </div>
                </div>
              </GridColumn>
            </GridRow>
          </Grid>
          {/* Mensaje de advertencia cuando el año está completo */}
          {yearComplete && !airEmissionsForm && (
            <div
              style={{
                position: "fixed",
                top: "80px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "90%",
                maxWidth: "800px",
                zIndex: 99999,
                backgroundColor: "#fffef5",
                border: "1px solid #e8e8e8",
                borderRadius: "6px",
                padding: "15px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                textAlign: "center"
              }}
            >
              <div style={{ fontSize: "1.1em", fontWeight: "600", color: "#666", marginBottom: "8px" }}>
                Meses del año completo
              </div>
              <p style={{ fontSize: "0.95em", margin: "0", color: "#555", lineHeight: "1.5" }}>
                Todos los periodos del año <strong>{formik.values.year}</strong> ya están cargados.
                <br />
                Por favor, seleccione otro año para crear un nuevo formulario.
                <br />
                Si desea editar un periodo existente, cierre esta ventana y seleccione el formulario a editar.
              </p>
            </div>
          )}
        </>
      ) : null}
      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "0.5rem" }}>
        <Popup
          content={t("read_invoice_tooltip") || "Leer documento"}
          trigger={
            <Form.Button
              type="button"
              color="teal"
              size="small"
              icon="file alternate"
              loading={invoiceLoading}
              onClick={() => setShowUploadModal(true)}
            />
          }
        />
      </div>
      <Table
        size="small"
        className="airemissions-form-table"
      >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              width="1"
              style={{ fontWeight: "bold", textAlign: "center" }}
            >
              {t("code")}
            </Table.HeaderCell>
            <Table.HeaderCell
              width="5"
              style={{ fontWeight: "bold", textAlign: "center" }}
            >
              {t("concept")}
            </Table.HeaderCell>
            <Table.HeaderCell
              width="2"
              style={{ fontWeight: "bold", textAlign: "center" }}
            >
              {t("value")}
            </Table.HeaderCell>
            {/* <Table.HeaderCell width="2">{t("pollutant")}</Table.HeaderCell> */}
            <Table.HeaderCell
              width="2"
              style={{ fontWeight: "bold", textAlign: "center" }}
            >
              {t("unit")}
            </Table.HeaderCell>
            <Table.HeaderCell
              width="2"
              style={{ fontWeight: "bold", textAlign: "center" }}
            >
              {t("state")}
            </Table.HeaderCell>
            <Table.HeaderCell
              style={{ fontWeight: "bold", textAlign: "center" }}
            >
              {t("actions")}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          <Table.Row className="airemissions-form-section-header">
            <Table.Cell colSpan={6}>Procesos y Operaciones</Table.Cell>
          </Table.Row>
          {findActiveFieldByName("carbon_dioxide") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.carbon_dioxide.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label"> {t("carbon_dioxide")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  name="carbon_dioxide.value"
                  onChange={formik.handleChange}
                  // onChange={(e, { name, value })=>
                  //   formik.setFieldValue("carbon_dioxide", value)
                  // }
                  value={formik.values.carbon_dioxide.value}
                  error={formik.errors.carbon_dioxide?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.carbon_dioxide?.unit &&
                    formik.touched.carbon_dioxide?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.carbon_dioxide.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("carbon_dioxide").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("carbon_dioxide.unit", data.value);
                      formik.setFieldTouched(
                        "carbon_dioxide.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError("carbon_dioxide.unit", undefined);
                      }
                    }}
                    value={formik.values.carbon_dioxide.unit}
                    error={
                      !!formik.errors.carbon_dioxide?.unit &&
                      !!formik.touched.carbon_dioxide?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.carbon_dioxide?.unit &&
                        formik.touched.carbon_dioxide?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "carbon_dioxide.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.carbon_dioxide.approvalStatus}
                  error={formik.errors.carbon_dioxide?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.carbon_dioxide.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.carbon_dioxide.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("carbon_dioxide"), "carbon_dioxide");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"carbon_dioxide"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("carbon_monoxide") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.carbon_monoxide.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <>
                  <label className="label">{t("carbon_monoxide")}</label>
                  {/* <Popup
                    content={t("carbon_monoxide_description")}
                    key={1}
                    header={t("carbon_monoxide")}
                    trigger={<Icon name="info circle" />}
                  /> */}
                </>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="carbon_monoxide.value"
                  value={formik.values.carbon_monoxide.value}
                  error={formik.errors.carbon_monoxide?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.carbon_monoxide?.unit &&
                    formik.touched.carbon_monoxide?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.carbon_monoxide.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("carbon_monoxide").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("carbon_monoxide.unit", data.value);
                      formik.setFieldTouched(
                        "carbon_monoxide.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError("carbon_monoxide.unit", undefined);
                      }
                    }}
                    value={formik.values.carbon_monoxide.unit}
                    error={
                      !!formik.errors.carbon_monoxide?.unit &&
                      !!formik.touched.carbon_monoxide?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.carbon_monoxide?.unit &&
                        formik.touched.carbon_monoxide?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "carbon_monoxide.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.carbon_monoxide.approvalStatus}
                  error={formik.errors.carbon_monoxide?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.carbon_monoxide.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("carbon_monoxide"), "carbon_monoxide");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"carbon_monoxide"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("particulate_material") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.particulate_material.code}{" "}
                </label>
              </Table.Cell>

              <Table.Cell>
                <label className="label">{t("particulate_material")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="particulate_material.value"
                  value={formik.values.particulate_material.value}
                  error={formik.errors.particulate_material?.value}
                />
              </Table.Cell>
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.particulate_material?.unit &&
                    formik.touched.particulate_material?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.particulate_material.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "particulate_material"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "particulate_material.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "particulate_material.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "particulate_material.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.particulate_material.unit}
                    error={
                      !!formik.errors.particulate_material?.unit &&
                      !!formik.touched.particulate_material?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.particulate_material?.unit &&
                        formik.touched.particulate_material?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "particulate_material.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.particulate_material.approvalStatus}
                  error={formik.errors.particulate_material?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.particulate_material.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("particulate_material"),
                          "particulate_material"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"particulate_material"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("volatile_organic_compounds") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.volatile_organic_compounds.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("volatile_organic_compounds")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="volatile_organic_compounds.value"
                  value={formik.values.volatile_organic_compounds.value}
                  error={formik.errors.volatile_organic_compounds?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.volatile_organic_compounds?.unit &&
                    formik.touched.volatile_organic_compounds?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.volatile_organic_compounds.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "volatile_organic_compounds"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "volatile_organic_compounds.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "volatile_organic_compounds.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "volatile_organic_compounds.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.volatile_organic_compounds.unit}
                    error={
                      !!formik.errors.volatile_organic_compounds?.unit &&
                      !!formik.touched.volatile_organic_compounds?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.volatile_organic_compounds?.unit &&
                        formik.touched.volatile_organic_compounds?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "volatile_organic_compounds.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.volatile_organic_compounds.approvalStatus
                  }
                  error={
                    formik.errors.volatile_organic_compounds?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.volatile_organic_compounds.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("volatile_organic_compounds"),
                          "volatile_organic_compounds"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"volatile_organic_compounds"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("sulfur_oxides") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.sulfur_oxides.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("sulfur_oxides")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="sulfur_oxides.value"
                  value={formik.values.sulfur_oxides.value}
                  error={formik.errors.sulfur_oxides?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.sulfur_oxides?.unit &&
                    formik.touched.sulfur_oxides?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.sulfur_oxides.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("sulfur_oxides").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("sulfur_oxides.unit", data.value);
                      formik.setFieldTouched("sulfur_oxides.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("sulfur_oxides.unit", undefined);
                      }
                    }}
                    value={formik.values.sulfur_oxides.unit}
                    error={
                      !!formik.errors.sulfur_oxides?.unit &&
                      !!formik.touched.sulfur_oxides?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.sulfur_oxides?.unit &&
                        formik.touched.sulfur_oxides?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>

              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "sulfur_oxides.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.sulfur_oxides.approvalStatus}
                  error={formik.errors.sulfur_oxides?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.sulfur_oxides.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("sulfur_oxides"), "sulfur_oxides");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"sulfur_oxides"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("nitrogen_oxides") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.nitrogen_oxides.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("nitrogen_oxides")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="nitrogen_oxides.value"
                  value={formik.values.nitrogen_oxides.value}
                  error={formik.errors.nitrogen_oxides?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.nitrogen_oxides?.unit &&
                    formik.touched.nitrogen_oxides?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.nitrogen_oxides.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("nitrogen_oxides").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("nitrogen_oxides.unit", data.value);
                      formik.setFieldTouched(
                        "nitrogen_oxides.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError("nitrogen_oxides.unit", undefined);
                      }
                    }}
                    value={formik.values.nitrogen_oxides.unit}
                    error={
                      !!formik.errors.nitrogen_oxides?.unit &&
                      !!formik.touched.nitrogen_oxides?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.nitrogen_oxides?.unit &&
                        formik.touched.nitrogen_oxides?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "nitrogen_oxides.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.nitrogen_oxides.approvalStatus}
                  error={formik.errors.nitrogen_oxides?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.nitrogen_oxides.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("nitrogen_oxides"), "nitrogen_oxides");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"nitrogen_oxides"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("chlorofluorocarbons") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.chlorofluorocarbons.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("chlorofluorocarbons")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="chlorofluorocarbons.value"
                  value={formik.values.chlorofluorocarbons.value}
                  error={formik.errors.chlorofluorocarbons?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.chlorofluorocarbons?.unit &&
                    formik.touched.chlorofluorocarbons?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.chlorofluorocarbons.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "chlorofluorocarbons"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "chlorofluorocarbons.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "chlorofluorocarbons.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "chlorofluorocarbons.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.chlorofluorocarbons.unit}
                    error={
                      !!formik.errors.chlorofluorocarbons?.unit &&
                      !!formik.touched.chlorofluorocarbons?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.chlorofluorocarbons?.unit &&
                        formik.touched.chlorofluorocarbons?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "chlorofluorocarbons.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.chlorofluorocarbons.approvalStatus}
                  error={formik.errors.chlorofluorocarbons?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.chlorofluorocarbons.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("chlorofluorocarbons"),
                          "chlorofluorocarbons"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"chlorofluorocarbons"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("hydrochlorofluorocarbons") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.hydrochlorofluorocarbons.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <>
                  <label className="label">
                    {t("hydrochlorofluorocarbons")}
                  </label>
                  <Popup
                    content={t("hydrochlorofluorocarbons")}
                    key={1}
                    header={t("hydrochlorofluorocarbons")}
                    trigger={<Icon name="info circle" />}
                  />
                </>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="hydrochlorofluorocarbons.value"
                  value={formik.values.hydrochlorofluorocarbons.value}
                  error={formik.errors.hydrochlorofluorocarbons?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.hydrochlorofluorocarbons?.unit &&
                    formik.touched.hydrochlorofluorocarbons?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.hydrochlorofluorocarbons.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "hydrochlorofluorocarbons"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "hydrochlorofluorocarbons.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "hydrochlorofluorocarbons.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "hydrochlorofluorocarbons.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.hydrochlorofluorocarbons.unit}
                    error={
                      !!formik.errors.hydrochlorofluorocarbons?.unit &&
                      !!formik.touched.hydrochlorofluorocarbons?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.hydrochlorofluorocarbons?.unit &&
                        formik.touched.hydrochlorofluorocarbons?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "hydrochlorofluorocarbons.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.hydrochlorofluorocarbons.approvalStatus}
                  error={formik.errors.hydrochlorofluorocarbons?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.hydrochlorofluorocarbons.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("hydrochlorofluorocarbons"),
                          "hydrochlorofluorocarbons"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"hydrochlorofluorocarbons"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("hydrofluorocarbons") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.hydrofluorocarbons.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("hydrofluorocarbons")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="hydrofluorocarbons.value"
                  value={formik.values.hydrofluorocarbons.value}
                  error={formik.errors.hydrofluorocarbons?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.hydrofluorocarbons?.unit &&
                    formik.touched.hydrofluorocarbons?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.hydrofluorocarbons.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "hydrofluorocarbons"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "hydrofluorocarbons.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "hydrofluorocarbons.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "hydrofluorocarbons.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.hydrofluorocarbons.unit}
                    error={
                      !!formik.errors.hydrofluorocarbons?.unit &&
                      !!formik.touched.hydrofluorocarbons?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.hydrofluorocarbons?.unit &&
                        formik.touched.hydrofluorocarbons?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "hydrofluorocarbons.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.hydrofluorocarbons.approvalStatus}
                  error={formik.errors.hydrofluorocarbons?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.hydrofluorocarbons.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("hydrofluorocarbons"),
                          "hydrofluorocarbons"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"hydrofluorocarbons"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("hydrofluoroolefins") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.hydrofluoroolefins.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("hydrofluoroolefins")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="hydrofluoroolefins.value"
                  value={formik.values.hydrofluoroolefins.value}
                  error={formik.errors.hydrofluoroolefins?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.hydrofluoroolefins?.unit &&
                    formik.touched.hydrofluoroolefins?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.hydrofluoroolefins.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "hydrofluoroolefins"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "hydrofluoroolefins.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "hydrofluoroolefins.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "hydrofluoroolefins.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.hydrofluoroolefins.unit}
                    error={
                      !!formik.errors.hydrofluoroolefins?.unit &&
                      !!formik.touched.hydrofluoroolefins?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.hydrofluoroolefins?.unit &&
                        formik.touched.hydrofluoroolefins?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "hydrofluoroolefins.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.hydrofluoroolefins.approvalStatus}
                  error={formik.errors.hydrofluoroolefins?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.hydrofluoroolefins.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("hydrofluoroolefins"),
                          "hydrofluoroolefins"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"hydrofluoroolefins"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("perfluorocarbons") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.perfluorocarbons.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("perfluorocarbons")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="perfluorocarbons.value"
                  value={formik.values.perfluorocarbons.value}
                  error={formik.errors.perfluorocarbons?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.perfluorocarbons?.unit &&
                    formik.touched.perfluorocarbons?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.perfluorocarbons.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("perfluorocarbons").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("perfluorocarbons.unit", data.value);
                      formik.setFieldTouched(
                        "perfluorocarbons.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "perfluorocarbons.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.perfluorocarbons.unit}
                    error={
                      !!formik.errors.perfluorocarbons?.unit &&
                      !!formik.touched.perfluorocarbons?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.perfluorocarbons?.unit &&
                        formik.touched.perfluorocarbons?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "perfluorocarbons.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.perfluorocarbons.approvalStatus}
                  error={formik.errors.perfluorocarbons?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.perfluorocarbons.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("perfluorocarbons"),
                          "perfluorocarbons"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"perfluorocarbons"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("substances_exhaust_ozone_layer") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.substances_exhaust_ozone_layer.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("substances_exhaust_ozone_layer")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="substances_exhaust_ozone_layer.value"
                  value={formik.values.substances_exhaust_ozone_layer.value}
                  error={formik.errors.substances_exhaust_ozone_layer?.value}
                />
              </Table.Cell>
              {/* <Table.Cell>
                <Form.Dropdown
                  options={listPollutants.map((ds) => {
                    return {
                      key: ds.key,
                      text: ds.name,
                      value: ds.value,
                    };
                  })}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "substances_exhaust_ozone_layer.pollutant",
                      data.value
                    )
                  }
                  value={formik.values.substances_exhaust_ozone_layer.pollutant}
                  error={formik.errors.substances_exhaust_ozone_layer}
                />
              </Table.Cell> */}
              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.substances_exhaust_ozone_layer?.unit &&
                    formik.touched.substances_exhaust_ozone_layer?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.substances_exhaust_ozone_layer.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "substances_exhaust_ozone_layer"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "substances_exhaust_ozone_layer.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "substances_exhaust_ozone_layer.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "substances_exhaust_ozone_layer.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.substances_exhaust_ozone_layer.unit}
                    error={
                      !!formik.errors.substances_exhaust_ozone_layer?.unit &&
                      !!formik.touched.substances_exhaust_ozone_layer?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.substances_exhaust_ozone_layer?.unit &&
                        formik.touched.substances_exhaust_ozone_layer?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "substances_exhaust_ozone_layer.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.substances_exhaust_ozone_layer.approvalStatus
                  }
                  error={
                    formik.errors.substances_exhaust_ozone_layer?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.substances_exhaust_ozone_layer.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("substances_exhaust_ozone_layer"),
                          "substances_exhaust_ozone_layer"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"substances_exhaust_ozone_layer"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("ozone") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.ozone.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("ozone")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="ozone.value"
                  value={formik.values.ozone.value}
                  error={formik.errors.ozone?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.ozone?.unit && formik.touched.ozone?.unit && (
                    <div style={{ color: "red", fontSize: "0.8em" }}>
                      {formik.errors.ozone.unit}
                    </div>
                  )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("ozone").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("ozone.unit", data.value);
                      formik.setFieldTouched("ozone.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("ozone.unit", undefined);
                      }
                    }}
                    value={formik.values.ozone.unit}
                    error={
                      !!formik.errors.ozone?.unit &&
                      !!formik.touched.ozone?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.ozone?.unit && formik.touched.ozone?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("ozone.approvalStatus", data.value)
                  }
                  value={formik.values.ozone.approvalStatus}
                  error={formik.errors.ozone?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.ozone.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("ozone"), "ozone");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"ozone"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName(
            "toxic_or_dangerous_atmospheric_pollutants"
          ) ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.toxic_or_dangerous_atmospheric_pollutants.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("toxic_or_dangerous_atmospheric_pollutants")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="toxic_or_dangerous_atmospheric_pollutants.value"
                  value={
                    formik.values.toxic_or_dangerous_atmospheric_pollutants
                      .value
                  }
                  error={
                    formik.errors.toxic_or_dangerous_atmospheric_pollutants
                      ?.value
                  }
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.toxic_or_dangerous_atmospheric_pollutants
                    ?.unit &&
                    formik.touched.toxic_or_dangerous_atmospheric_pollutants
                      ?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {
                          formik.errors
                            .toxic_or_dangerous_atmospheric_pollutants.unit
                        }
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "toxic_or_dangerous_atmospheric_pollutants"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "toxic_or_dangerous_atmospheric_pollutants.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "toxic_or_dangerous_atmospheric_pollutants.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "toxic_or_dangerous_atmospheric_pollutants.unit",
                          undefined
                        );
                      }
                    }}
                    value={
                      formik.values.toxic_or_dangerous_atmospheric_pollutants
                        .unit
                    }
                    error={
                      !!formik.errors.toxic_or_dangerous_atmospheric_pollutants
                        ?.unit &&
                      !!formik.touched.toxic_or_dangerous_atmospheric_pollutants
                        ?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.toxic_or_dangerous_atmospheric_pollutants
                          ?.unit &&
                        formik.touched.toxic_or_dangerous_atmospheric_pollutants
                          ?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "toxic_or_dangerous_atmospheric_pollutants.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.toxic_or_dangerous_atmospheric_pollutants
                      .approvalStatus
                  }
                  error={
                    formik.errors.toxic_or_dangerous_atmospheric_pollutants
                      ?.approvalStatus
                  }
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("toxic_or_dangerous_atmospheric_pollutants"),
                          "toxic_or_dangerous_atmospheric_pollutants"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"toxic_or_dangerous_atmospheric_pollutants"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("ammonia") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.ammonia.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("ammonia")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="ammonia.value"
                  value={formik.values.ammonia.value}
                  error={formik.errors.ammonia?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.ammonia?.unit &&
                    formik.touched.ammonia?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.ammonia.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("ammonia").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("ammonia.unit", data.value);
                      formik.setFieldTouched("ammonia.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("ammonia.unit", undefined);
                      }
                    }}
                    value={formik.values.ammonia.unit}
                    error={
                      !!formik.errors.ammonia?.unit &&
                      !!formik.touched.ammonia?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.ammonia?.unit &&
                        formik.touched.ammonia?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("ammonia.approvalStatus", data.value)
                  }
                  value={formik.values.ammonia.approvalStatus}
                  error={formik.errors.ammonia?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.ammonia.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("ammonia"), "ammonia");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"ammonia"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("propane") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.propane.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("propane")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="propane.value"
                  value={formik.values.propane.value}
                  error={formik.errors.propane?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.propane?.unit &&
                    formik.touched.propane?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.propane.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("propane").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("propane.unit", data.value);
                      formik.setFieldTouched("propane.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("propane.unit", undefined);
                      }
                    }}
                    value={formik.values.propane.unit}
                    error={
                      !!formik.errors.propane?.unit &&
                      !!formik.touched.propane?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.propane?.unit &&
                        formik.touched.propane?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("propane.approvalStatus", data.value)
                  }
                  value={formik.values.propane.approvalStatus}
                  error={formik.errors.propane?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.propane.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("propane"), "propane");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"propane"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("isobutane") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.isobutane.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("isobutane")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="isobutane.value"
                  value={formik.values.isobutane.value}
                  error={formik.errors.isobutane?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.isobutane?.unit &&
                    formik.touched.isobutane?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.isobutane.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("isobutane").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("isobutane.unit", data.value);
                      formik.setFieldTouched("isobutane.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("isobutane.unit", undefined);
                      }
                    }}
                    value={formik.values.isobutane.unit}
                    error={
                      !!formik.errors.isobutane?.unit &&
                      !!formik.touched.isobutane?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.isobutane?.unit &&
                        formik.touched.isobutane?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("isobutane.approvalStatus", data.value)
                  }
                  value={formik.values.isobutane.approvalStatus}
                  error={formik.errors.isobutane?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.isobutane.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("isobutane"), "isobutane");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"isobutane"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("propylene") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.propylene.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("propylene")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="propylene.value"
                  value={formik.values.propylene.value}
                  error={formik.errors.propylene?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.propylene?.unit &&
                    formik.touched.propylene?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.propylene.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("propylene").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("propylene.unit", data.value);
                      formik.setFieldTouched("propylene.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("propylene.unit", undefined);
                      }
                    }}
                    value={formik.values.propylene.unit}
                    error={
                      !!formik.errors.propylene?.unit &&
                      !!formik.touched.propylene?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.propylene?.unit &&
                        formik.touched.propylene?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("propylene.approvalStatus", data.value)
                  }
                  value={formik.values.propylene.approvalStatus}
                  error={formik.errors.propylene?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.propylene.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("propylene"), "propylene");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"propylene"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("ethylene") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.ethylene.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("ethylene")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="ethylene.value"
                  value={formik.values.ethylene.value}
                  error={formik.errors.ethylene?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.ethylene?.unit &&
                    formik.touched.ethylene?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.ethylene.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("ethylene").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("ethylene.unit", data.value);
                      formik.setFieldTouched("ethylene.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("ethylene.unit", undefined);
                      }
                    }}
                    value={formik.values.ethylene.unit}
                    error={
                      !!formik.errors.ethylene?.unit &&
                      !!formik.touched.ethylene?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.ethylene?.unit &&
                        formik.touched.ethylene?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("ethylene.approvalStatus", data.value)
                  }
                  value={formik.values.ethylene.approvalStatus}
                  error={formik.errors.ethylene?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.ethylene.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("ethylene"), "ethylene");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"ethylene"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("hexafluoroethane") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.hexafluoroethane.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("hexafluoroethane")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="hexafluoroethane.value"
                  value={formik.values.hexafluoroethane.value}
                  error={formik.errors.hexafluoroethane?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.hexafluoroethane?.unit &&
                    formik.touched.hexafluoroethane?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.hexafluoroethane.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("hexafluoroethane").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("hexafluoroethane.unit", data.value);
                      formik.setFieldTouched(
                        "hexafluoroethane.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "hexafluoroethane.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.hexafluoroethane.unit}
                    error={
                      !!formik.errors.hexafluoroethane?.unit &&
                      !!formik.touched.hexafluoroethane?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.hexafluoroethane?.unit &&
                        formik.touched.hexafluoroethane?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "hexafluoroethane.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.hexafluoroethane.approvalStatus}
                  error={formik.errors.hexafluoroethane?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.hexafluoroethane.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("hexafluoroethane"),
                          "hexafluoroethane"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"hexafluoroethane"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("octafluoropropane") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.octafluoropropane.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("octafluoropropane")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="octafluoropropane.value"
                  value={formik.values.octafluoropropane.value}
                  error={formik.errors.octafluoropropane?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.octafluoropropane?.unit &&
                    formik.touched.octafluoropropane?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.octafluoropropane.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "octafluoropropane"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "octafluoropropane.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "octafluoropropane.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "octafluoropropane.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.octafluoropropane.unit}
                    error={
                      !!formik.errors.octafluoropropane?.unit &&
                      !!formik.touched.octafluoropropane?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.octafluoropropane?.unit &&
                        formik.touched.octafluoropropane?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "octafluoropropane.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.octafluoropropane.approvalStatus}
                  error={formik.errors.octafluoropropane?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.octafluoropropane.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("octafluoropropane"),
                          "octafluoropropane"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"octafluoropropane"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("chlorotrifluoromethane") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.chlorotrifluoromethane.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("chlorotrifluoromethane")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="chlorotrifluoromethane.value"
                  value={formik.values.chlorotrifluoromethane.value}
                  error={formik.errors.chlorotrifluoromethane?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.chlorotrifluoromethane?.unit &&
                    formik.touched.chlorotrifluoromethane?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.chlorotrifluoromethane.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "chlorotrifluoromethane"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "chlorotrifluoromethane.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "chlorotrifluoromethane.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "chlorotrifluoromethane.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.chlorotrifluoromethane.unit}
                    error={
                      !!formik.errors.chlorotrifluoromethane?.unit &&
                      !!formik.touched.chlorotrifluoromethane?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.chlorotrifluoromethane?.unit &&
                        formik.touched.chlorotrifluoromethane?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "chlorotrifluoromethane.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.chlorotrifluoromethane.approvalStatus}
                  error={formik.errors.chlorotrifluoromethane?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.chlorotrifluoromethane.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("chlorotrifluoromethane"),
                          "chlorotrifluoromethane"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"chlorotrifluoromethane"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("chlorodifluoromethane") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.chlorodifluoromethane.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("chlorodifluoromethane")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="chlorodifluoromethane.value"
                  value={formik.values.chlorodifluoromethane.value}
                  error={formik.errors.chlorodifluoromethane?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.chlorodifluoromethane?.unit &&
                    formik.touched.chlorodifluoromethane?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.chlorodifluoromethane.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "chlorodifluoromethane"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "chlorodifluoromethane.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "chlorodifluoromethane.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "chlorodifluoromethane.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.chlorodifluoromethane.unit}
                    error={
                      !!formik.errors.chlorodifluoromethane?.unit &&
                      !!formik.touched.chlorodifluoromethane?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.chlorodifluoromethane?.unit &&
                        formik.touched.chlorodifluoromethane?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "chlorodifluoromethane.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.chlorodifluoromethane.approvalStatus}
                  error={formik.errors.chlorodifluoromethane?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.chlorodifluoromethane.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("chlorodifluoromethane"),
                          "chlorodifluoromethane"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"chlorodifluoromethane"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("tetrafluoroethane") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.tetrafluoroethane.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("tetrafluoroethane")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="tetrafluoroethane.value"
                  value={formik.values.tetrafluoroethane.value}
                  error={formik.errors.tetrafluoroethane?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.tetrafluoroethane?.unit &&
                    formik.touched.tetrafluoroethane?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.tetrafluoroethane.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "tetrafluoroethane"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "tetrafluoroethane.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "tetrafluoroethane.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "tetrafluoroethane.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.tetrafluoroethane.unit}
                    error={
                      !!formik.errors.tetrafluoroethane?.unit &&
                      !!formik.touched.tetrafluoroethane?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.tetrafluoroethane?.unit &&
                        formik.touched.tetrafluoroethane?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "tetrafluoroethane.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.tetrafluoroethane.approvalStatus}
                  error={formik.errors.tetrafluoroethane?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.tetrafluoroethane.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("tetrafluoroethane"),
                          "tetrafluoroethane"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"tetrafluoroethane"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("trifluoromethane") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.trifluoromethane.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("trifluoromethane")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="trifluoromethane.value"
                  value={formik.values.trifluoromethane.value}
                  error={formik.errors.trifluoromethane?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.trifluoromethane?.unit &&
                    formik.touched.trifluoromethane?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.trifluoromethane.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("trifluoromethane").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("trifluoromethane.unit", data.value);
                      formik.setFieldTouched(
                        "trifluoromethane.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "trifluoromethane.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.trifluoromethane.unit}
                    error={
                      !!formik.errors.trifluoromethane?.unit &&
                      !!formik.touched.trifluoromethane?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.trifluoromethane?.unit &&
                        formik.touched.trifluoromethane?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "trifluoromethane.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.trifluoromethane.approvalStatus}
                  error={formik.errors.trifluoromethane?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.trifluoromethane.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("trifluoromethane"),
                          "trifluoromethane"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"trifluoromethane"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("pentafluoroethane") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.pentafluoroethane.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("pentafluoroethane")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="pentafluoroethane.value"
                  value={formik.values.pentafluoroethane.value}
                  error={formik.errors.pentafluoroethane?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.pentafluoroethane?.unit &&
                    formik.touched.pentafluoroethane?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.pentafluoroethane.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "pentafluoroethane"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "pentafluoroethane.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "pentafluoroethane.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "pentafluoroethane.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.pentafluoroethane.unit}
                    error={
                      !!formik.errors.pentafluoroethane?.unit &&
                      !!formik.touched.pentafluoroethane?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.pentafluoroethane?.unit &&
                        formik.touched.pentafluoroethane?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "pentafluoroethane.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.pentafluoroethane.approvalStatus}
                  error={formik.errors.pentafluoroethane?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.pentafluoroethane.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("pentafluoroethane"),
                          "pentafluoroethane"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"pentafluoroethane"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("hexafluoropropylene") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.hexafluoropropylene.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("hexafluoropropylene")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="hexafluoropropylene.value"
                  value={formik.values.hexafluoropropylene.value}
                  error={formik.errors.hexafluoropropylene?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.hexafluoropropylene?.unit &&
                    formik.touched.hexafluoropropylene?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.hexafluoropropylene.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits(
                      "hexafluoropropylene"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "hexafluoropropylene.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "hexafluoropropylene.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "hexafluoropropylene.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.hexafluoropropylene.unit}
                    error={
                      !!formik.errors.hexafluoropropylene?.unit &&
                      !!formik.touched.hexafluoropropylene?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.hexafluoropropylene?.unit &&
                        formik.touched.hexafluoropropylene?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "hexafluoropropylene.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.hexafluoropropylene.approvalStatus}
                  error={formik.errors.hexafluoropropylene?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.hexafluoropropylene.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("hexafluoropropylene"),
                          "hexafluoropropylene"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"hexafluoropropylene"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("hydrogen") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.hydrogen.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("hydrogen")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="hydrogen.value"
                  value={formik.values.hydrogen.value}
                  error={formik.errors.hydrogen?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.hydrogen?.unit &&
                    formik.touched.hydrogen?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.hydrogen.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("hydrogen").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: ds.name,
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("hydrogen.unit", data.value);
                      formik.setFieldTouched("hydrogen.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("hydrogen.unit", undefined);
                      }
                    }}
                    value={formik.values.hydrogen.unit}
                    error={
                      !!formik.errors.hydrogen?.unit &&
                      !!formik.touched.hydrogen?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.hydrogen?.unit &&
                        formik.touched.hydrogen?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("hydrogen.approvalStatus", data.value)
                  }
                  value={formik.values.hydrogen.approvalStatus}
                  error={formik.errors.hydrogen?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.hydrogen.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("hydrogen"), "hydrogen");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"hydrogen"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("methane") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.methane.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("methane")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="methane.value"
                  value={formik.values.methane.value}
                  error={formik.errors.methane?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.methane?.unit &&
                    formik.touched.methane?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.methane.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    //placeholder="Celda datos fijos"
                    options={determineAirEmissionsUnits("methane").map((ds) => {
                      return {
                        key: ds.key,
                        text: ds.name,
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("methane.unit", data.value);
                      formik.setFieldTouched("methane.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("methane.unit", undefined);
                      }
                    }}
                    value={formik.values.methane.unit}
                    error={
                      !!formik.errors.methane?.unit &&
                      !!formik.touched.methane?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.methane?.unit &&
                        formik.touched.methane?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("methane.approvalStatus", data.value)
                  }
                  value={formik.values.methane.approvalStatus}
                  error={formik.errors.methane}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("methane"), "methane");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"methane"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("oxygen") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.oxygen.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("oxygen")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="oxygen.value"
                  value={formik.values.oxygen.value}
                  error={formik.errors.oxygen?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.oxygen?.unit &&
                    formik.touched.oxygen?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.oxygen.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineAirEmissionsUnits("oxygen").map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("oxygen.unit", data.value);
                      formik.setFieldTouched("oxygen.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("oxygen.unit", undefined);
                      }
                    }}
                    value={formik.values.oxygen.unit}
                    error={
                      !!formik.errors.oxygen?.unit &&
                      !!formik.touched.oxygen?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.oxygen?.unit &&
                        formik.touched.oxygen?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("oxygen.approvalStatus", data.value)
                  }
                  value={formik.values.oxygen.approvalStatus}
                  error={formik.errors.oxygen?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.oxygen.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("oxygen"), "oxygen");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"oxygen"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("nitrogen") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">{formik.values.nitrogen.code} </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("nitrogen")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="nitrogen.value"
                  value={formik.values.nitrogen.value}
                  error={formik.errors.nitrogen?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.nitrogen?.unit &&
                    formik.touched.nitrogen?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.nitrogen.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineAirEmissionsUnits("nitrogen").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("nitrogen.unit", data.value);
                      formik.setFieldTouched("nitrogen.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("nitrogen.unit", undefined);
                      }
                    }}
                    value={formik.values.nitrogen.unit}
                    error={
                      !!formik.errors.nitrogen?.unit &&
                      !!formik.touched.nitrogen?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.nitrogen?.unit &&
                        formik.touched.nitrogen?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue("nitrogen.approvalStatus", data.value)
                  }
                  value={formik.values.nitrogen.approvalStatus}
                  error={formik.errors.nitrogen?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.nitrogen.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("nitrogen"), "nitrogen");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"nitrogen"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("hydrogen_sulfide") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.hydrogen_sulfide.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("hydrogen_sulfide")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="hydrogen_sulfide.value"
                  value={formik.values.hydrogen_sulfide.value}
                  error={formik.errors.hydrogen_sulfide?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.hydrogen_sulfide?.unit &&
                    formik.touched.hydrogen_sulfide?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.hydrogen_sulfide.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineAirEmissionsUnits("hydrogen_sulfide").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("hydrogen_sulfide.unit", data.value);
                      formik.setFieldTouched(
                        "hydrogen_sulfide.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "hydrogen_sulfide.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.hydrogen_sulfide.unit}
                    error={
                      !!formik.errors.hydrogen_sulfide?.unit &&
                      !!formik.touched.hydrogen_sulfide?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.hydrogen_sulfide?.unit &&
                        formik.touched.hydrogen_sulfide?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "hydrogen_sulfide.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.hydrogen_sulfide.approvalStatus}
                  error={formik.errors.hydrogen_sulfide?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.hydrogen_sulfide.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("hydrogen_sulfide"),
                          "hydrogen_sulfide"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"hydrogen_sulfide"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("carbon_disulfide") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.carbon_disulfide.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("carbon_disulfide")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="carbon_disulfide.value"
                  value={formik.values.carbon_disulfide.value}
                  error={formik.errors.carbon_disulfide?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.carbon_disulfide?.unit &&
                    formik.touched.carbon_disulfide?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.carbon_disulfide.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineAirEmissionsUnits("carbon_disulfide").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("carbon_disulfide.unit", data.value);
                      formik.setFieldTouched(
                        "carbon_disulfide.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "carbon_disulfide.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.carbon_disulfide.unit}
                    error={
                      !!formik.errors.carbon_disulfide?.unit &&
                      !!formik.touched.carbon_disulfide?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.carbon_disulfide?.unit &&
                        formik.touched.carbon_disulfide?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "carbon_disulfide.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.carbon_disulfide.approvalStatus}
                  error={formik.errors.carbon_disulfide?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.carbon_disulfide.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("carbon_disulfide"),
                          "carbon_disulfide"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"carbon_disulfide"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          {findActiveFieldByName("nitrous_oxide") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.nitrous_oxide.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("nitrous_oxide")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="nitrous_oxide.value"
                  value={formik.values.nitrous_oxide.value}
                  error={formik.errors.nitrous_oxide?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.nitrous_oxide?.unit &&
                    formik.touched.nitrous_oxide?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.nitrous_oxide.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineAirEmissionsUnits("nitrous_oxide").map(
                      (ds) => {
                        return {
                          key: ds.key,
                          text: t(ds.name),
                          value: ds.value,
                        };
                      }
                    )}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue("nitrous_oxide.unit", data.value);
                      formik.setFieldTouched("nitrous_oxide.unit", true, false);
                      if (data.value) {
                        formik.setFieldError("nitrous_oxide.unit", undefined);
                      }
                    }}
                    value={formik.values.nitrous_oxide.unit}
                    error={
                      !!formik.errors.nitrous_oxide?.unit &&
                      !!formik.touched.nitrous_oxide?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.nitrous_oxide?.unit &&
                        formik.touched.nitrous_oxide?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "nitrous_oxide.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.nitrous_oxide.approvalStatus}
                  error={formik.errors.nitrous_oxide?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.nitrous_oxide.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(t("nitrous_oxide"), "nitrous_oxide");
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"nitrous_oxide"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}

          <Table.Row className="airemissions-form-section-header">
            <Table.Cell colSpan={6}>Refrigerantes</Table.Cell>
          </Table.Row>
          {findActiveFieldByName("hydrochlorofluorocarbons_ref") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.hydrochlorofluorocarbons_ref.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">
                  {t("hydrochlorofluorocarbons_ref")}
                </label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="hydrochlorofluorocarbons_ref.value"
                  value={formik.values.hydrochlorofluorocarbons_ref.value}
                  error={formik.errors.hydrochlorofluorocarbons_ref?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.hydrochlorofluorocarbons_ref?.unit &&
                    formik.touched.hydrochlorofluorocarbons_ref?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.hydrochlorofluorocarbons_ref.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineAirEmissionsUnits(
                      "hydrochlorofluorocarbons_ref"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "hydrochlorofluorocarbons_ref.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "hydrochlorofluorocarbons_ref.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "hydrochlorofluorocarbons_ref.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.hydrochlorofluorocarbons_ref.unit}
                    error={
                      !!formik.errors.hydrochlorofluorocarbons_ref?.unit &&
                      !!formik.touched.hydrochlorofluorocarbons_ref?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.hydrochlorofluorocarbons_ref?.unit &&
                        formik.touched.hydrochlorofluorocarbons_ref?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "hydrochlorofluorocarbons_ref.approvalStatus",
                      data.value
                    )
                  }
                  value={
                    formik.values.hydrochlorofluorocarbons_ref.approvalStatus
                  }
                  error={
                    formik.errors.hydrochlorofluorocarbons_ref?.approvalStatus
                  }
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.hydrochlorofluorocarbons_ref.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("hydrochlorofluorocarbons_ref"),
                          "hydrochlorofluorocarbons_ref"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"hydrochlorofluorocarbons_ref"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("hydrofluorocarbons_ref") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.hydrofluorocarbons_ref.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("hydrofluorocarbons_ref")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="hydrofluorocarbons_ref.value"
                  value={formik.values.hydrofluorocarbons_ref.value}
                  error={formik.errors.hydrofluorocarbons_ref?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.hydrofluorocarbons_ref?.unit &&
                    formik.touched.hydrofluorocarbons_ref?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.hydrofluorocarbons_ref.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineAirEmissionsUnits(
                      "hydrofluorocarbons_ref"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "hydrofluorocarbons_ref.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "hydrofluorocarbons_ref.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "hydrofluorocarbons_ref.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.hydrofluorocarbons_ref.unit}
                    error={
                      !!formik.errors.hydrofluorocarbons_ref?.unit &&
                      !!formik.touched.hydrofluorocarbons_ref?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.hydrofluorocarbons_ref?.unit &&
                        formik.touched.hydrofluorocarbons_ref?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "hydrofluorocarbons_ref.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.hydrofluorocarbons_ref.approvalStatus}
                  error={formik.errors.hydrofluorocarbons_ref?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.hydrofluorocarbons_ref.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("hydrofluorocarbons_ref"),
                          "hydrofluorocarbons_ref"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"hydrofluorocarbons_ref"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("hydrofluoroolefins_ref") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.hydrofluoroolefins_ref.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("hydrofluoroolefins_ref")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="hydrofluoroolefins_ref.value"
                  value={formik.values.hydrofluoroolefins_ref.value}
                  error={formik.errors.hydrofluoroolefins_ref?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.hydrofluoroolefins_ref?.unit &&
                    formik.touched.hydrofluoroolefins_ref?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.hydrofluoroolefins_ref.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineAirEmissionsUnits(
                      "hydrofluoroolefins_ref"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "hydrofluoroolefins_ref.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "hydrofluoroolefins_ref.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "hydrofluoroolefins_ref.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.hydrofluoroolefins_ref.unit}
                    error={
                      !!formik.errors.hydrofluoroolefins_ref?.unit &&
                      !!formik.touched.hydrofluoroolefins_ref?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.hydrofluoroolefins_ref?.unit &&
                        formik.touched.hydrofluoroolefins_ref?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "hydrofluoroolefins_ref.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.hydrofluoroolefins_ref.approvalStatus}
                  error={formik.errors.hydrofluoroolefins_ref?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.hydrofluoroolefins_ref.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("hydrofluoroolefins_ref"),
                          "hydrofluoroolefins_ref"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"hydrofluoroolefins_ref"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
          {findActiveFieldByName("perfluorocarbonos_ref") ? (
            <Table.Row>
              <Table.Cell>
                <label className="label">
                  {formik.values.perfluorocarbonos_ref.code}{" "}
                </label>
              </Table.Cell>
              <Table.Cell>
                <label className="label">{t("perfluorocarbonos_ref")}</label>
              </Table.Cell>
              <Table.Cell>
                <Form.Input
                  type="number"
                  onChange={formik.handleChange}
                  name="perfluorocarbonos_ref.value"
                  value={formik.values.perfluorocarbonos_ref.value}
                  error={formik.errors.perfluorocarbonos_ref?.value}
                />
              </Table.Cell>

              <Table.Cell>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "2px",
                  }}
                >
                  {/* Error en header */}
                  {formik.errors.perfluorocarbonos_ref?.unit &&
                    formik.touched.perfluorocarbonos_ref?.unit && (
                      <div style={{ color: "red", fontSize: "0.8em" }}>
                        {formik.errors.perfluorocarbonos_ref.unit}
                      </div>
                    )}
                  <Form.Dropdown
                    options={determineAirEmissionsUnits(
                      "perfluorocarbonos_ref"
                    ).map((ds) => {
                      return {
                        key: ds.key,
                        text: t(ds.name),
                        value: ds.value,
                      };
                    })}
                    selection
                    disabled={!isAdmin(user.role)}
                    onChange={(_, data) => {
                      formik.setFieldValue(
                        "perfluorocarbonos_ref.unit",
                        data.value
                      );
                      formik.setFieldTouched(
                        "perfluorocarbonos_ref.unit",
                        true,
                        false
                      );
                      if (data.value) {
                        formik.setFieldError(
                          "perfluorocarbonos_ref.unit",
                          undefined
                        );
                      }
                    }}
                    value={formik.values.perfluorocarbonos_ref.unit}
                    error={
                      !!formik.errors.perfluorocarbonos_ref?.unit &&
                      !!formik.touched.perfluorocarbonos_ref?.unit
                    }
                    style={{
                      minWidth: "120px",
                      borderColor:
                        formik.errors.perfluorocarbonos_ref?.unit &&
                        formik.touched.perfluorocarbonos_ref?.unit
                          ? "red"
                          : undefined,
                    }}
                  />
                </div>
              </Table.Cell>
              <Table.Cell>
                <Form.Dropdown
                  placeholder={t("select")}
                  options={[
                    {
                      key: 1,
                      value: "approved",
                      text: t("aproveed"),
                      label: { color: "green", empty: true, circular: true },
                    },
                    {
                      key: 2,
                      value: "pending",
                      text: t("pending"),
                      label: { color: "yellow", empty: true, circular: true },
                    },
                    {
                      key: 3,
                      value: "rejected",
                      text: t("rejected"),
                      label: { color: "red", empty: true, circular: true },
                    },
                  ]}
                  selection
                  onChange={(_, data) =>
                    formik.setFieldValue(
                      "perfluorocarbonos_ref.approvalStatus",
                      data.value
                    )
                  }
                  value={formik.values.perfluorocarbonos_ref.approvalStatus}
                  error={formik.errors.perfluorocarbonos_ref?.approvalStatus}
                  disabled={isEditor(user.role)}
                  style={getApprovalStatusStyle(
                    formik.values.perfluorocarbonos_ref.approvalStatus,
                    isEditor(user.role)
                  )}
                />
                {/* {formik.values.product_category.approvalStatus?  <Icon color="green" name='checkmark' /> : <Icon color="red" name='close' />} */}
              </Table.Cell>
              <Table.Cell>
                <Popup
                  content={t("add_comment")}
                  trigger={
                    <Button
                      icon
                      color="teal"
                      type="button"
                      onClick={() => {
                        openUpdateSite(
                          t("perfluorocarbonos_ref"),
                          "perfluorocarbonos_ref"
                        );
                      }}
                    >
                      <Icon name="comment outline" />
                    </Button>
                  }
                />
                <FileUpload
                  accessToken={accessToken}
                  data={formik}
                  field={"perfluorocarbonos_ref"}
                  newFiles={newFiles}
                  setNewFiles={setNewFiles}
                  t={t}
                />
              </Table.Cell>
            </Table.Row>
          ) : null}
        </Table.Body>

        {/* <TableFooter fullWidth>
      <TableRow>
        <TableHeaderCell />
        <TableHeaderCell colSpan='4'>
          <Button
            floated='right'
            labelPosition='left'
            secundary
            size='small'
          > Aprobar todos
          </Button>
        </TableHeaderCell>
      </TableRow>
    </TableFooter> */}
      </Table>

      <ToastContainer
        position="bottom-center"
        autoClose={1200}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <BasicModal
        show={showModal}
        onClose={() => setShowModal(false)} // cerrar desde aquí
        title={titleModal}
        size="tiny"
        closeOnDimmerClick={false} // evita cierre al hacer clic fuera
        closeOnEscape={false} // opcional
      >
        <div onClick={(e) => e.stopPropagation()}>
          <Comments
            formik={formik}
            fieldName={fieldName}
            onClose={() => setShowModal(false)}
            onReload={onReload}
            airEmissionsForm={airEmissionsForm}
            user={user}
            t={t}
          />
        </div>
      </BasicModal>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          gap: "0.5rem",
          marginRight: 20,
          marginTop: 20,
          alignItems: "center",
        }}
      >
        <Button
          type="submit"
          primary
          size="large"
          loading={formik.isSubmitting}
          content={!airEmissionsForm ? t("save") : t("update")}
        />

        <Button
          type="button"
          color="red"
          secondary
          size="large"
          onClick={() => {
            onClose ? onClose() : goBack();
          }}
        >
          {t("cancel")}
        </Button>
      </div>

      <Modal open={showUploadModal} onClose={() => !invoiceLoading && setShowUploadModal(false)} size="small" closeOnDimmerClick={!invoiceLoading} className="invoice-reader-modal">
        <Modal.Header><Icon name="file alternate outline" /> {t("read_invoice") || "Leer documento"}</Modal.Header>
        <Modal.Content>
          <InvoiceDropzone onFiles={processInvoiceFiles} loading={invoiceLoading} t={t} inputRef={invoiceInputRef} onInputChange={handleInvoiceFileChange} />
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={() => setShowUploadModal(false)} disabled={invoiceLoading}>{t("cancel")}</Button>
        </Modal.Actions>
      </Modal>

      <Modal open={showInvoiceModal} onClose={() => setShowInvoiceModal(false)} size="small" closeOnDimmerClick={false} className="invoice-preview-modal">
        <Modal.Header><Icon name="file alternate outline" /> {t("extracted_invoice_data") || "Datos extraídos"}</Modal.Header>
        <Modal.Content>
          {invoiceResults.length > 0 && (
            <div className="invoice-reader-preview">
              <Message info size="small" style={{ marginBottom: "1rem" }}>
                <Icon name="info circle" />
                {t("review_before_applying") || "Revisá los datos antes de aplicar. Hacé clic en Aplicar en la fila deseada."}
              </Message>
              <Table size="small" compact>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell>{t("file") || "Archivo"}</Table.HeaderCell>
                    <Table.HeaderCell>{t("period") || "Período"}</Table.HeaderCell>
                    <Table.HeaderCell></Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {invoiceResults.map((r, i) => (
                    <Table.Row key={i} negative={!!r.error}>
                      <Table.Cell>
                        <Icon name="paperclip" />
                        <span style={{ fontSize: "0.85em" }}>{r.filename}</span>
                        {r.format && <span style={{ marginLeft: "0.4rem", background: "#e8f4fd", color: "#1a6ba0", borderRadius: "4px", padding: "1px 6px", fontSize: "0.72rem", fontWeight: 600, textTransform: "uppercase" }}>{r.format}</span>}
                      </Table.Cell>
                      <Table.Cell>{r.error ? <span style={{color:"red"}}>{r.error}</span> : r.period ? <strong>{r.period}/{r.year}</strong> : <span style={{color:"#aaa"}}>{t("not_detected") || "No detectado"}</span>}</Table.Cell>
                      <Table.Cell>
                        {!r.error && (
                          <Button size="mini" color="teal" onClick={() => handleApplyInvoiceData(r)}>
                            <Icon name="check" /> {t("apply") || "Aplicar"}
                          </Button>
                        )}
                      </Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button secondary onClick={() => setShowInvoiceModal(false)}><Icon name="close" /> {t("cancel")}</Button>
        </Modal.Actions>
      </Modal>
    </Form>
  );
}

function InvoiceDropzone({ onFiles, loading, t, inputRef, onInputChange }) {
  const [isDragOver, setIsDragOver] = useState(false);
  const { getRootProps, getInputProps } = useDropzone({
    accept: { "application/pdf": [], "image/*": [], "text/csv": [], "application/vnd.ms-excel": [], "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [], "text/plain": [] },
    multiple: true, disabled: loading, noClick: true, noKeyboard: true,
    onDrop: (accepted) => { if (accepted.length > 0) onFiles(accepted); },
    onDragEnter: () => setIsDragOver(true),
    onDragLeave: () => setIsDragOver(false),
    onDropAccepted: () => setIsDragOver(false),
    onDropRejected: () => setIsDragOver(false),
  });
  return (
    <div {...getRootProps()} style={{ border: `2px dashed ${isDragOver ? "#648EBC" : "#b0c4de"}`, borderRadius: "12px", padding: "2.5rem 1.5rem", minHeight: "260px", textAlign: "center", cursor: loading ? "not-allowed" : "pointer", background: isDragOver ? "#f0f6ff" : "#fafafa", transition: "all 0.2s ease", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "1rem" }}>
      <input {...getInputProps()} />
      <input ref={inputRef} type="file" accept=".pdf,.jpg,.jpeg,.png,.webp,.csv,.xlsx,.xls,.txt" multiple style={{ display: "none" }} onChange={onInputChange} />
      {loading ? (
        <><img src={`${process.env.PUBLIC_URL}/favicon.png`} alt="sustemia" className="invoice-dropzone-spinner" /><p style={{ color: "#648EBC", fontWeight: 600 }}>{t("processing")}</p></>
      ) : (
        <><Icon name="cloud upload" size="huge" color="blue" style={{ margin: 0 }} />
          <p style={{ margin: 0, fontSize: "1rem", fontWeight: 500, color: "#333" }}>{t("drag_drop_files")}</p>
          <p style={{ margin: 0, color: "#888", fontSize: "0.85rem" }}>o</p>
          <Button type="button" primary onClick={(e) => { e.stopPropagation(); inputRef.current?.click(); }}><Icon name="folder open outline" />{t("select_files")}</Button>
          <p style={{ margin: 0, color: "#aaa", fontSize: "0.75rem" }}>{t("supported_formats")}</p>
        </>
      )}
    </div>
  );
}

function Comments({ formik, user, fieldName, onClose, t }) {
  const [comment, setComment] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleAddComment = () => {
    if (comment.trim().length > 0) {
      const reviews = [...(formik.values[fieldName].reviews || [])];

      reviews.push({
        comments: comment.trim(),
        date: new Date(),
        reviewer_user: user ? user._id : null,
      });

      formik.setFieldValue(`${fieldName}.reviews`, reviews);
      setComment("");
      setSuccessMessage(t("comment_added_success"));
    }
  };

  const handleSaveComment = (id, editedContent) => {
    const reviews = [...formik.values[fieldName].reviews];
    reviews[id] = {
      ...reviews[id],
      comments: editedContent.trim(),
      date: new Date(),
    };
    formik.setFieldValue(`${fieldName}.reviews`, reviews);
  };

  const reviews = formik.values[fieldName]?.reviews || [];

  return (
    <CommentGroup minimal>
      <Header as="h4" dividing>{t("comments")}</Header>
      {reviews.map((review, index) => (
        <React.Fragment key={index}>
          <EditableComment
            id={index}
            author={
              review.reviewer_user
                ? review.reviewer_user === user._id
                  ? `${user.firstname} ${user.lastname}`
                  : `${review.reviewer_user.firstname} ${review.reviewer_user.lastname}`
                : ""
            }
            date={formatDateHourCompleted(review.date)}
            content={review.comments}
            onSave={handleSaveComment}
            active={review.reviewer_user === user._id}
            t={t}
          />
          <Divider fitted /> {console.log(review)}
        </React.Fragment>
      ))}

      {successMessage && (
        <Message positive>
          <Message.Header>{successMessage}</Message.Header>
        </Message>
      )}

      {/* ✨ Form con preventDefault para evitar submit accidental */}
      <Form reply className="comments-reply-form" onSubmit={(e) => e.preventDefault()}>
        <Form.TextArea
          placeholder={t("write_a_comment")}
          rows={3}
          style={{ minHeight: 100 }}
          onChange={(_, data) => setComment(data.value)}
          value={comment}
        />

        <div
          style={{
            display: "flex",
            gap: "1em",
            marginTop: "1em",
            justifyContent: "center",
          }}
        >
          <Button
            type="button" // importante para no disparar submit
            icon="edit"
            content={t("add_comment")}
            primary
            onClick={handleAddComment}
            style={{ flex: 1 }}
          />
          <Button
            type="button" // importante para no disparar submit
            content={t("close")}
            secondary
            onClick={onClose}
            style={{ flex: 1 }}
          />
        </div>
      </Form>
    </CommentGroup>
  );
}
function EditableComment({ id, author, date, content, onSave, active, t }) {
  const [isEditing, setIsEditing] = useState(false);
  const [editedContent, setEditedContent] = useState(content);

  const handleChange = (e) => setEditedContent(e.target.value);
  const handleEdit = () => setIsEditing(true);
  const handleCancel = () => {
    setEditedContent(content);
    setIsEditing(false);
  };
  const handleSave = () => {
    if (editedContent.trim()) {
      onSave(id, editedContent);
      setIsEditing(false);
    }
  };

  const initials = author
    ? author.split(' ').map((n) => n[0]).join('').slice(0, 2).toUpperCase()
    : '?';

  return (
    <div style={{
      display: 'flex',
      gap: '10px',
      padding: '10px 12px',
      borderRadius: '10px',
      backgroundColor: '#f4f6f9',
      marginBottom: '8px',
    }}>
      <div style={{
        width: '36px',
        height: '36px',
        borderRadius: '50%',
        backgroundColor: '#648EBC',
        color: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '13px',
        fontWeight: '700',
        flexShrink: 0,
      }}>
        {initials}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '8px', marginBottom: '4px' }}>
          <span style={{ fontWeight: '700', fontSize: '13px', color: '#1A1C40' }}>{author}</span>
          <span style={{ fontSize: '11px', color: '#999' }}>{date}</span>
        </div>
        {isEditing ? (
          <Form reply>
            <Form.TextArea value={editedContent} onChange={handleChange} rows={3} />
            <div style={{ display: "flex", gap: "0.5rem", marginTop: "0.5rem", justifyContent: "center" }}>
              <Button type="button" icon="check" circular primary className="btn-comment-edit-action" onClick={handleSave} />
              <Button type="button" icon="times" circular secondary className="btn-comment-edit-action" onClick={handleCancel} />
            </div>
          </Form>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '8px' }}>
            <p style={{ margin: 0, fontSize: '13px', color: '#333', wordBreak: 'break-word' }}>{content}</p>
            {active && (
              <Icon
                name="pencil"
                size="small"
                style={{ cursor: 'pointer', color: '#aaa', flexShrink: 0, marginTop: '2px' }}
                onClick={handleEdit}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
}

function FileViewer(props) {
  const { fileName, fileUniqueName, handleRemove, t } = props;
  const [fileUrl, setFileUrl] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  useEffect(() => {
    if (fileName) {
      const url = airEmissionsFormController.getFileApi(fileUniqueName);
      setFileUrl(url);
    }
  }, [fileName]);

  const handleOpenPreview = (event) => {
    event.preventDefault();
    setPreviewOpen(true);
  };

  const handleClosePreview = (event) => {
    event.preventDefault(); // Previene el comportamiento predeterminado
    setPreviewOpen(false);
  };

  return (
    <>
      <List.Content floated="left">{fileName}</List.Content>
      <List.Content floated="right">
        {" "}
        <Button
          color="red"
          onClick={() => handleRemove(fileUniqueName)}
          icon="trash alternate"
        />
      </List.Content>
      {/* //<Button onClick={handleOpenPreview}> {fileName}</Button> */}
      <List.Content floated="right">
        <Modal
          onClose={handleClosePreview}
          onOpen={handleOpenPreview}
          open={previewOpen}
          trigger={
            <Button primary icon>
              <Icon name="eye" />
            </Button>
          }
        >
          <ModalHeader>{fileName}</ModalHeader>
          <ModalContent>
            {fileName &&
              (fileName.endsWith(".jpg") ||
                fileName.endsWith(".png") ||
                fileName.endsWith(".jpeg")) && (
                <Image
                  src={fileUrl}
                  alt="Vista previa"
                  style={{ maxWidth: "100%" }}
                />
              )}
            {fileName && fileName.endsWith(".pdf") && (
              <iframe
                src={fileUrl}
                title={t("preview")}
                style={{ width: "100%", height: "500px" }}
              />
            )}
          </ModalContent>
          <ModalActions>
            {/* <Button color="red" onClick={() => handleRemove(fileName)}>
            <Icon disabled name="trash alternate" /> Eliminar
          </Button> */}
            <Button color="black" onClick={handleClosePreview}>
              <Icon disabled name="close" />
              {t("close")}
            </Button>
          </ModalActions>
        </Modal>
      </List.Content>
    </>
  );
}

function FileUpload(props) {
  const { accessToken, data, field, newFiles, setNewFiles, t } = props;
  const [files, setFiles] = useState([]);
  const [filesView, setFilesView] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [openModal, setOpenModal] = useState(false); // Para controlar el estado del modal

  useEffect(() => {
    if (data.values[field].files) {
      setFilesView(data.values[field].files); // Construye la URL del archivo
    }
  }, [data.values[field].files]);

  const handleButtonClick = (event) => {
    event.preventDefault(); // Evita que el formulario se envíe
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.onchange = handleFileChange;
    input.click();
  };

  // Maneja el cambio cuando se seleccionan archivos
  const handleFileChange = async (e) => {
    e.preventDefault(); // Evita que el formulario se envíe
    const selectedFiles = e.target.files;
    setNewFiles({ ...newFiles, [field]: Array.from(selectedFiles) });
    //data.setFieldValue(`${field}.files`,Array.from(selectedFiles))
    setFiles([...selectedFiles]);
  };

  // Función para cerrar el modal
  const closeModal = (event) => {
    event.preventDefault();
    setOpenModal(!openModal);
  };

  const handleRemoveFile = async (file) => {
    try {
      const updatedFiles = filesView.filter((f) => f.uniqueName !== file);
      setFilesView(updatedFiles);
      const response = await airEmissionsFormController.deleteFileApi(
        accessToken,
        file
      );
      //setMessage(response.message);
      removeFile(updatedFiles);
    } catch (error) {
      // setMessage('Error al elimianr el archivo');
    }
  };

  const removeFile = async (updatedFiles) => {
    data.setFieldValue(`${field}.files`, updatedFiles);
  };

  return (
    <>
      {/* Input para seleccionar los archivos */}
      {/* <Input
        type="file"
        multiple
        icon={"paperclip"}
        onChange={handleFileUpload}
      /> */}

      <Popup
        content={t("upload_file")}
        trigger={
          <Button
            default
            size="small"
            onClick={handleButtonClick}
            icon="paperclip"
            color={
              newFiles[field] && newFiles[field].length > 0 ? "green" : "grey"
            }
          ></Button>
        }
      />
      {/* Mensajes de éxito o error */}
      {successMessage && (
        <Message success>
          <Message.Header>Éxito</Message.Header>
          <p>{successMessage}</p>
        </Message>
      )}

      {errorMessage && (
        <Message error>
          <Message.Header>Error</Message.Header>
          <p>{errorMessage}</p>
        </Message>
      )}

      <Popup
        content={t("view_file")}
        trigger={
          <Button
            primary
            size="small"
            onClick={closeModal}
            icon="eye"
          ></Button>
        }
      />
      {/* Modal para mostrar los archivos subidos */}
      <BasicModal show={openModal} close={closeModal} title="Archivos subidos" size="tiny">
          <List divided>
            {filesView.length > 0 && (
              <>
                <Header as="h4">Archivos existentes</Header>
                {filesView.map((filePath, index) => (
                  <List.Item key={index}>
                    <FileViewer
                      fileName={filePath.name}
                      fileUniqueName={filePath.uniqueName}
                      handleRemove={handleRemoveFile}
                      t={t}
                    />
                  </List.Item>
                ))}
              </>
            )}
            {newFiles[field] && newFiles[field].length > 0 && (
              <>
                <Header as="h4">
                  Archivos nuevos (se guardarán al enviar)
                </Header>
                {newFiles[field].map((file, index) => (
                  <List.Item key={`new-${index}`}>
                    <List.Content floated="left">{file.name}</List.Content>
                    <List.Content floated="right">
                      <Button
                        color="blue"
                        onClick={() => window.open(URL.createObjectURL(file), '_blank')}
                        icon="eye"
                      />
                      <Button
                        color="red"
                        onClick={() => {
                          const updatedNewFiles = newFiles[field].filter(
                            (_, i) => i !== index
                          );
                          setNewFiles({
                            ...newFiles,
                            [field]: updatedNewFiles,
                          });
                        }}
                        icon="trash alternate"
                      />
                    </List.Content>
                  </List.Item>
                ))}
              </>
            )}
            {filesView.length === 0 &&
              (!newFiles[field] || newFiles[field].length === 0) && (
                <p>No se encontraron archivos subidos.</p>
              )}
          </List>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '1.5em' }}>
            <Button secondary onClick={closeModal}>{t("close")}</Button>
          </div>
      </BasicModal>
    </>
  );
}
